import React, { forwardRef } from 'react';
import { object, array, string, bool } from 'prop-types';

import CollectionItem from '../CollectionItem/CollectionItem';

import './CollectionList.scss';

const CollectionList = forwardRef(
  ({ title, items, staticText, isCollapsible }, ref) => {
    if (!items.length) return null;

    return (
      <div className="collection-list" ref={ref}>
        <h1 className="collection-list__title">{title}</h1>
        <div>
          {items.map((item) => (
            <CollectionItem
              key={item.id}
              name={item.name}
              title={item.title}
              endTime={item.endTime}
              startTime={item.startTime}
              date={item.date}
              type={item.type}
              description={item.description}
              pictures={item.picture}
              link={item.link}
              subDescription={item.subDescription}
              staticText={staticText}
              isCollapsible={isCollapsible}
            />
          ))}
        </div>
      </div>
    );
  },
);

CollectionList.propTypes = {
  title: string,
  items: array,
  staticText: object,
  isCollapsible: bool,
};

CollectionList.defaultProps = {
  title: '',
  items: [],
  staticText: {},
  isCollapsible: true,
};

export default CollectionList;
